import {Component, HostBinding, input} from '@angular/core';
import {IsEmptyModule} from '@employee-pages/shared/pipes/is-empty/is-empty.module';
import {UIComponentsModule} from '@ui-app/app.module';
import {DatePipe} from '@angular/common';

@Component({
    selector: 'employee-grid-cell',
    standalone: true,
    imports: [
        IsEmptyModule,
        UIComponentsModule,
        DatePipe
    ],
    templateUrl: './grid-cell.component.html',
    styleUrl: './grid-cell.component.less'
})
export class GridCellComponent {
    cellTitle = input<string>('');
    cellData = input<any>();

    // @HostBinding('class.full-width')
    fillWidth = input<boolean>(false);
    isDate = input<boolean>(false);

    @HostBinding('class.full-width')
    get fillWidthCell(): boolean {
        return this.fillWidth();
    }
}
